/* icons */
import coffee from '../images/icons/Coffee.png'
import graph from '../images/icons/Graph.png'
import layers from '../images/icons/Layers.png'
import settings from '../images/icons/Settings.png'
/* full images */
import alexPhoto from '../images/people/alex.jpg'
import andrewPhoto from '../images/people/andrew.jpg'
import brianPhoto from '../images/people/brian.jpg'
import laurenPhoto from '../images/people/lauren.jpg'
import mattPhoto from '../images/people/matt.jpg'
import rachelPhoto from '../images/people/rachel.jpg'
/* thumbnails */
import alexThumbnail from '../images/thumbnails/alex.jpg'
import andrewThumbnail from '../images/thumbnails/andrew.jpg'
import brianThumbnail from '../images/thumbnails/brian.jpg'
import laurenThumbnail from '../images/thumbnails/lauren.jpg'
import mattThumbnail from '../images/thumbnails/matt.jpg'
import rachelThumbnail from '../images/thumbnails/rachel.jpg'

const persons = {
  'alex-biles': {
    name: 'Alex Biles',
    slug: 'alex-biles',
    photo: alexPhoto,
    thumbnail: alexThumbnail,
    icon: layers,
    iconAlt: 'Design',
    description: (
      'Alex is an award winning, passionate, and driven creative'
      + ' professional. He has experience as an Art Director, a Graphic'
      + ' Designer, and a Web Developer. He is dedicated to creating and'
      + ' delivering elegant marketing solutions for clients and projects'
      + ' of all sizes. He thrives in collaborative environments and seeks'
      + ' to constantly learn, grow, and adapt.'
    ),
    siteUrl: 'http://alexbiles.com',
    siteTitle: "Alex's Website",
    githubName: '',
    twitterHandle: '',
  },
  'andrew-pinkham': {
    name: 'Andrew Pinkham',
    slug: 'andrew-pinkham',
    photo: andrewPhoto,
    thumbnail: andrewThumbnail,
    icon: settings,
    iconAlt: 'Lead Engineer',
    description: (
      'Andrew Pinkham is the founder and lead engineer at JamBon'
      + ' Software, which provides development consulting services. He'
      + ' is the author of Django Unleashed (Pearson;'
      + ' https://django-unleashed.com), and provides instruction in'
      + ' Python, Django, and JavaScript. Andrew specializes in web and mobile'
      + ' products, but is also passionate about usability, security,'
      + ' and distributed systems. He is a graduate of Dartmouth'
      + ' College with a degree in Computer Science and currently'
      + ' resides in Boston, MA.'
    ),
    siteTitle: 'JamBon Software Homepage',
    siteUrl: 'http://jambonsw.com',
    site2Title: 'Django Unleashed Website',
    site2Url: 'https://django-unleashed.com',
    githubName: 'jambonrose',
    twitterHandle: 'andrewsforge',
  },
  'brian-meyers': {
    name: 'Brian Meyers',
    slug: 'brian-meyers',
    photo: brianPhoto,
    thumbnail: brianThumbnail,
    icon: graph,
    iconAlt: 'Business',
    description: (
      'Brian was previously a strategy and market research'
      + ' consultant at L.E.K., focusing on private equity, tech, and'
      + ' healthcare clients. Prior to joining JamBon Software, he was'
      + ' the head of product management for Clear Ballot, an election'
      + ' technology firm, where he oversaw the launch of their'
      + ' initial product and the expansion of their portfolio to'
      + ' include four other product lines. He leverages his'
      + ' experiences to improve clients’ user experience and tailor'
      + ' JamBon Software’s products to specific client needs.'
    ),
    siteTitle: 'JamBon Software Homepage',
    siteUrl: 'http://jambonsw.com',
    githubName: 'thecompass',
    twitterHandle: '',
  },
  'lauren-grant': {
    name: 'Lauren Grant',
    slug: 'lauren-grant',
    photo: laurenPhoto,
    thumbnail: laurenThumbnail,
    icon: coffee,
    iconAlt: 'Engineer',
    description: (
      'Lauren is a software engineer who has experience in writing'
      + ' frontend applications in JavaScript, React, HTML5 and CSS'
      + ' frameworks. Her prior work experience includes being the'
      + ' Executive Assistant for the Board of Governors at the Boston'
      + ' Architectural College and a Modern Design Consultant at'
      + ' AllModern.com. Both positions exposed her to a love for'
      + ' great design, which she brings to her work in web'
      + ' development. Lauren has a B.S. in Psychobiology from Wheaton'
      + ' College in Norton, MA and a certificate in Web Development'
      + ' from General Assembly in Boston, MA.'
    ),
    siteTitle: "Lauren's Portfolio",
    siteUrl: 'http://laurengrantportfolio.bitballoon.com',
    githubName: 'LaurenGrant',
    twitterHandle: '',
  },
  'matt-schoen': {
    name: 'Matt Schoen',
    slug: 'matt-schoen',
    photo: mattPhoto,
    thumbnail: mattThumbnail,
    icon: coffee,
    iconAlt: 'Engineer',
    description: (
      'Matt’s experience in interactive web work, video games, and'
      + ' virtual reality speak to his ability to build immersive user'
      + ' experiences. Having spent the last 5 years working with'
      + ' startups and as a consultant, Matt’s expertise is not only'
      + ' in development but also in his ability to leverage and'
      + ' extend existing brand equity at both the product and the'
      + ' company level. His experience as the VP of VR'
      + ' (https://startwithv.com/) further demonstrates his broad'
      + ' range of skills. He currently works at Unity.'
    ),
    siteTitle: "Matt's Website",
    siteUrl: 'http://mtschoen.com',
    githubName: 'mtschoen',
    twitterHandle: 'mtschoen',
  },
  'rachel-stevens': {
    name: 'Rachel Stevens',
    slug: 'rachel-stevens',
    photo: rachelPhoto,
    thumbnail: rachelThumbnail,
    icon: coffee,
    iconAlt: 'Engineer',
    description: (
      'Rachel is a full-stack developer with great interpersonal'
      + ' skills. She loves both front end and the back end development'
      + ' and is looking for an opportunity where she can work in both'
      + ' worlds. Rachel is interested in making slick, usable,'
      + ' responsive websites. '
    ),
    siteTitle: "Rachel's Website",
    siteUrl: 'http://www.racheltstevens.com',
    githubName: 'raq929',
    twitterHandle: '',
  },
}

export default persons



// WEBPACK FOOTER //
// ./src/gallery/defaultPersons.js